import React from "react";
import "./RetailHero.css";
import { HeroImage } from "../../../../images/Images";
import GradientButton from "../../../../components/button/Button";

const Hero: React.FC = () => {
  return (
    <div className="retail__hero">
      <div className="retail__hero_text">
        <h3>
          We are bringing the world, <span>Home</span>
        </h3>
        <p>
          Pamundo makes shopping of traditional spices, locally sourced produce,
          and artisanal goods easier and faster, connecting you to your heritage
          flavors and more.
        </p>
        <div className="retail__hero-btn">
          <GradientButton
            text="Continue as a retailer"
            onClick={() => (window.location.href = "/signup")}
          />
        </div>
      </div>

      <div className="retail__hero__image">
        <img src={HeroImage} alt="" />
      </div>
    </div>
  );
};

export default Hero;
